import { h as __h } from "preact";
import html from "~/util/html.js";
import Avatar from "~/component/Avatar.js";
import util from "~/style/util.js";
import { adopt, importCss, CSS_MODULE_SCRIPTS } from "~/util/css.js";
const {
  default: sheet
} = CSS_MODULE_SCRIPTS ? await import("./UserStack.module.css", {
  with: {
    type: "css"
  }
}) : await importCss("./UserStack.module.css", import.meta.url);
const css = adopt(sheet);

/**
 * @typedef {object} Props
 * @property {string} name
 * @property {string} email
 */

/** @param {Props} props */
export default function UserStack({
  name,
  email
}) {
  return __h("div", {
    "class": css.stack + " " + util.truncate
  }, __h(Avatar, {
    name: name,
    size: 24
  }), __h("div", {}, __h("div", {
    "class": util.truncate
  }, name), __h("div", {
    "class": util.truncate + " " + css.sub
  }, email)));
}